/* globals google */
class Amenities {
  constructor (map, center) {
    this.data = {};
    this.data.service = new google.maps.places.PlacesService(map);
    this.data.map = map;
    this.data.center = center;
    this.data.markers = [];
  }

  createServicesMarker (place) {
    const infowindow = new google.maps.InfoWindow({
      // content: require('./google-map-infowindow')(place);
    });

    const marker = new google.maps.Marker({
      map: this.data.map,
      position: place.geometry.location
    });

    marker.addListener('mouseover', () => {
      this.hideInfoWindows();
      infowindow.open(marker);
    });

    this.data.markers.push(marker);
  }

  hideInfoWindows () {
    this.data.markers.map((marker) => {
      marker.infowindow.close(this.data.map, marker);
    });
  }
}

module.exports = Amenities;
